<template>
  <div class="home_vue_comp">
    <v-main>
      <banner></banner>

      <!-- <div class="video-container" style="margin-top: 100px; height: 1000px">
        <video id="herovideo" ref="herovideo" loop muted>
          <source src="../assets/bg-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div class="content-video">
          <h1>Your Content Here</h1>
          <p>This text is over the video background.</p>
        </div>
      </div> -->
      <v-container class="pa-0" id="home-container">
        <v-row class="hero-text-container ma-0 mt-lg-10">
          <!-- video -->
          <!-- playsinline -->
          <!-- <video
            id="hero_vid"
            class=""
            autoplay
            loop
            style="background-image: url(../images/bg-video.mp4)"
            muted
            playsinline
          ></video> -->
          <!-- animation -->
          <!-- HERO section -->
          <v-col
            cols="12"
            class="d-flex flex-column justify-start align-start px-0"
          >
            <!-- large and extra large image -->
            <div class="lg-hero-text d-none d-lg-flex">
              <div
                id="herovidcont"
                style="
                  position: absolute;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  z-index: 0;
                  height: 950px;
                  overflow: hidden;
                "
              >
                <video
                  id="herovid"
                  ref="herovid"
                  class=""
                  autoplay
                  loop
                  muted
                  style="
                    background-image: url(../assets/bg-video-poster-00001.jpg);
                  "
                >
                  <source src="../assets/bg-video.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div class="hero_bg-video-overlay"></div>
              </div>
              <div class="lg-animation-div d-none d-lg-flex flex-column">
                <img
                  src="../images/herotext.png"
                  class="hero-animation"
                  alt=""
                />
                <h4 class="hero-animation hero-sub-text mt-lg-0 mt-4">
                  Reno Police Department is currently accepting applications for
                  Police Officer Recruits and Lateral Police Officers.
                </h4>
                <v-btn
                  href="https://www.governmentjobs.com/careers/reno?keywords=police%20officer"
                  target="_blank"
                  rel="noopener"
                  outlined
                  color="gold"
                  class="hero-animation hero-text-btn button mt-lg-12 mt-5"
                  style="color: white !important"
                  >Apply now
                </v-btn>
              </div>
            </div>

            <!-- medium-->
            <div class="md-hero-text d-none d-md-flex d-lg-none">
              <div
                id="herovidcont"
                style="
                  position: absolute;
                  top: 0;
                  width: 100%;

                  z-index: 0;
                  height: 1336px;
                  overflow: hidden;
                "
              >
                <video
                  id="herovid"
                  ref="herovid"
                  class=""
                  autoplay
                  loop
                  muted
                  @timeupdate="onTimeUpdate"
                  style="
                    background-image: url(../assets/bg-video-poster-00001.jpg);
                  "
                >
                  <source src="../assets/bg-video.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div class="hero_bg-video-overlay"></div>
                <!-- <div class="content-video">Current time: {{ currentTime }} seconds</div> -->
              </div>
              <div
                class="md-animation-div d-none d-md-flex d-lg-none pt-md flex-column"
              >
                <img
                  src="../images/herotext-md.png"
                  class="hero-animation ml-lg-2"
                  alt=""
                />
                <h4
                  class="hero-animation hero-sub-text ml-md-8 ml-lg-8 mt-lg-0 mt-4"
                >
                  Reno Police Department is currently accepting applications for
                  Police Officer Recruits and Lateral Police Officers.
                </h4>
                <v-btn
                  href="https://www.governmentjobs.com/careers/reno?keywords=police%20officer"
                  target="_blank"
                  rel="noopener"
                  outlined
                  color="gold"
                  class="hero-animation hero-text-btn button ml-md-8 ml-lg-12 mt-lg-12 mt-5"
                  style="color: white !important"
                  >Apply now
                </v-btn>
              </div>
            </div>

            <!-- small-->
            <div class="sm-hero-text d-flex d-sm-none">
              <div
                id="herovidcont"
                style="
                  position: absolute;
                  top: 0;
                  width: 950px;
                  height: 100%;
                  z-index: 0;
                  height: 920px;
                  overflow: hidden;
                "
              >
                <video
                  id="herovid"
                  ref="herovid"
                  class="videojnb"
                  autoplay
                  loop
                  muted
                  @timeupdate="onTimeUpdate"
                  style="
                    background-image: url(../images/bg-video-poster-00001.jpg);
                  "
                >
                  <source src="../assets/bg-video.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div class="hero_bg-video-overlay"></div>
                <!-- <div class="content-video">Current time: {{ currentTime }} seconds</div> -->
              </div>
            </div>

            <div class="sm-animation-div sm-hero-text pl-3 d-md-none">
              <!-- ml-lg-2 -->
              <img
                src="../images/herotext-sm.png"
                class="hero-animation"
                alt=""
              />

              <h4
                class="hero-animation hero-sub-text ml-md-8 ml-lg-8 mt-lg-0 mt-4"
              >
                Reno Police Department is currently accepting applications for
                Police Officer Recruits and Lateral Police Officers.
              </h4>
              <v-btn
                href="https://www.governmentjobs.com/careers/reno?keywords=police%20officer"
                target="_blank"
                rel="noopener"
                outlined
                color="gold"
                class="hero-animation hero-text-btn button ml-md-8 ml-lg-12 mt-lg-12 mt-5"
                style="color: white !important"
                >Apply now
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- Recruit -->
      <v-container class="recruit-padding-xxlarge">
        <v-row class="md-recruit d-flex justify-center">
          <!-- Recruit Pic small -->
          <div
            class="recruit-right-animationxxx d-flex justify-center d-md-none recruit-pic trans100"
          >
            <img src="../images/recruit-p-500.jpeg" class="mr-lg-13" alt="" />
          </div>
          <v-col
            cols="12"
            class="d-flex flex-column flex-md-row justify-space-between align-start"
          >
            <div
              class="recruit-left-animationxxx recruit-text d-flex flex-column justify-start align-start transback100"
            >
              <!-- large and extra large text image -->
              <div class="lg-recruit-text d-none d-lg-flex">
                <img
                  src="../images/recruittext.png"
                  class="hero-animation ml-lg-2"
                  alt=""
                />
              </div>

              <!-- medium-->
              <div class="md-recruit-text d-none d-md-flex d-lg-none">
                <img
                  src="../images/recruittext-md.png"
                  class="hero-animation ml-lg-2"
                  alt=""
                />
              </div>

              <!-- small and medium text image -->
              <div class="sm-recruit-text d-flex justify-sm-center d-sm-none">
                <img
                  src="../images/recruittext-sm.png"
                  class="hero-animation ml-lg-2"
                  alt=""
                />
              </div>
              <div
                style="width: 100%; height: 1px; transform: translateX(200%)"
                id="intersect1"
                v-intersect="onIntersect1"
                v-if="anim1_ready"
              ></div>
              <h5 class="recruit-sub-text ml-md-8 ml-lg-8">
                This is the entry-level classification for Police Officer.
                Recruits will participate in a 22 week Police Academy. Upon
                graduation from the Academy, Recruits will be promoted to Police
                Officers with a starting annual salary of about
                <span class="text-weight-semibold text-color-gold"
                  >$76,000*</span
                >
                and earn up to $105,000.
                <p class="text-size-small text-color-gold">
                  *We also offer 5% on top of base pay for associates and 8% for
                  a Bachelor's degree.
                </p>
              </h5>

              <v-expansion-panels class="recruit-expansion ml-md-8 ml-lg-8">
                <!-- Qualifications Expansion Panel -->
                <v-expansion-panel class="mb-3">
                  <v-expansion-panel-header
                    class="qualification-expansion text-color-gold exp-header-style px-0"
                  >
                    Minimum Qualifications
                    <template v-slot:actions>
                      <v-icon color="#ba9c58" x-large> $chevdown </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    class="qual-list"
                    color="black
                  "
                  >
                    <ul class="">
                      <li>
                        Graduation from high school or equivalent such as a GED
                      </li>
                      <li>A citizen of the United States of America</li>
                      <li>Possession of a valid driver's license</li>
                      <li>At least 20 years of age</li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-btn
                href="https://www.governmentjobs.com/careers/reno/jobs/4562139/police-officer-recruit"
                target="_blank"
                rel="noopener"
                outlined
                color="gold"
                class="button recruit-text-btn ml-md-8 ml-lg-12 mt-lg-8"
                style="color: white !important"
                >Apply now
              </v-btn>
            </div>
            <!-- Recruit Pic md and large  -->
            <div
              class="recruit-right-animationxxx recruit-pic d-none d-md-flex trans100"
            >
              <img src="../images/recruit-p-500.jpeg" class="mr-lg-13" alt="" />
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- Lateral -->
      <v-container class="lateral-padding-xxlarge">
        <v-row class="md-lateral d-flex justify-center">
          <v-col
            cols="12"
            class="d-flex flex-column flex-md-row justify-space-between align-start"
          >
            <!-- lateral Pic -->
            <div
              class="lateral-left-animationxxx lateral-pic d-flex justify-center transback100"
            >
              <img src="../images/lateral-p-500.jpeg" class="mr-lg-13" alt="" />
            </div>

            <!-- lateral text -->
            <div
              id="lateral_text"
              class="lateral-right-animationxxx lateral-text d-flex flex-column justify-start align-start trans100"
            >
              <!-- <img
                src="/ClientApp/public/images/lateraltext.png"
                class="ml-lg-2"
                alt=""
              /> -->

              <!-- large and extra large text image -->
              <div class="lg-hero-text d-none d-lg-flex">
                <img
                  src="../images/lateraltext.png"
                  class="hero-animation mr-lg-2"
                  alt=""
                />
              </div>

              <!-- medium-->
              <div class="md-lateral-text d-none d-md-flex d-lg-none">
                <img
                  src="../images/lateraltext-md.png"
                  class="hero-animation ml-lg-2"
                  alt=""
                />
              </div>

              <!-- small -->
              <div class="sm-lateral-text d-flex d-sm-none">
                <img
                  src="../images/lateraltext-sm.png"
                  class="hero-animation ml-lg-2 mt-2 mt-sm-0"
                  alt=""
                />
              </div>
              <div
                style="width: 100%; height: 1px; transform: translateX(-200%)"
                id="intersect2"
                v-intersect="onIntersect2"
                v-if="anim1_ready"
              ></div>
              <h5 class="lateral-sub-text ml-md-8 ml-lg-8">
                Reno PD is actively seeking experienced law enforcement officers
                who are passionate about public safety to be part of our
                dedicated force. As a member of our team, you'll have the
                opportunity to serve the community with excellence while earning
                up to
                <span class="text-weight-semibold text-color-gold">
                  $108,000* </span
                >annually.
                <p class="text-size-small text-color-gold">
                  *We also offer 5% on top of base pay for associates and 8% for
                  a Bachelor's degree.
                </p>
              </h5>

              <v-expansion-panels class="lateral-expansion ml-md-8 ml-lg-8">
                <!-- Qualifications Expansion Panel -->
                <v-expansion-panel class="mb-3">
                  <v-expansion-panel-header
                    class="qualification-expansion text-color-gold exp-header-style px-0"
                  >
                    Minimum Qualifications
                    <template v-slot:actions>
                      <v-icon color="#ba9c58" x-large> $chevdown </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    class="qual-list"
                    color="black
                  "
                  >
                    <ul>
                      <li>EDUCATION:</li>
                      <ul class="mb-lg-1">
                        <li>High School Diploma or equivalent.</li>
                      </ul>
                      <li>
                        EXPERIENCE:
                        <ul class="mb-lg-1">
                          <li>
                            Two years of patrol experience (may include
                            probationary time)<strong>OR</strong>
                          </li>
                          <li>
                            Successful completion of the Northern Nevada Law
                            Enforcement Academy (NNLEA).
                          </li>
                        </ul>
                      </li>
                      <li>
                        LICENSE AND CERTIFICATE:
                        <ul class="mb-lg-1">
                          <li>
                            Possess and maintain the equivalent to a valid
                            Nevada Class C driver’s license at the time of
                            application and at time of hire.
                          </li>
                          <li>
                            Possession of a Nevada POST Category 1 Certificate,
                            or an out-of-state POST Category 1 Certificate which
                            has reciprocity with Nevada. Basic Certificate must
                            be in good standing.
                          </li>
                        </ul>
                      </li>
                      <li>
                        OTHER REQUIREMENTS:
                        <ul class="mb-lg-1">
                          <li>
                            Must be 21 years of age at time of appointment.
                          </li>
                          <li>Must be a citizen of the United States.</li>
                          <li>
                            Must pass the Nevada POST Physical Fitness Test, per
                            NAC 289.
                          </li>
                          <li>
                            Non NV POST holders must pass the online Reciprocity
                            course, per NAC 289.
                          </li>
                          <li>
                            Non NV POST holders must pass the Nevada State
                            Certification exam, per NAC 289.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-btn
                href="https://www.governmentjobs.com/careers/reno/jobs/4562473/lateral-police-officer"
                target="_blank"
                rel="noopener"
                outlined
                color="gold"
                class="button lateral-text-btn ml-md-8 ml-lg-12 mt-lg-8"
                style="color: white !important"
                >Apply now
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- About-pic -->
      <v-container class="pt-16 pt-4">
        <v-row>
          <v-col
            cols="12"
            class="about-pic-animationxxx about-pic pa-0 pb-lg-16"
            style="opacity: 0"
          >
            <img src="../images/about-pic.png" class="" alt="" />
          </v-col>
        </v-row>
        <div
          style="width: 100%; height: 1px"
          id="intersect_aboutpic"
          v-intersect="onIntersect_aboutpic"
          v-if="anim1_ready"
        ></div>
        <!-- about text -->
        <v-row
          class="about-text about-text-bckground d-flex flex-column align-center pt-lg-16"
        >
          <v-col cols="12" class="d-flex flex-column align-center">
            <!-- <div class="about-text-animation full-width d-flex justify-center">
              <img
                src="/ClientApp/public/images/servicetext.png"
                class=""
                alt=""
              />
            </div> -->
            <div id="about-text-animationxxx">
              <!-- large and extra large image -->
              <div
                class="lg-about-text d-none d-lg-flex about-text-animationxxx full-width justify-center"
                style="opacity: 0"
              >
                <!-- "hero-animation mr-lg-2" -->
                <img src="../images/servicetext.png" alt="" />
              </div>

              <!-- medium-->
              <div
                class="md-about-text d-none d-md-flex justify-md-center d-lg-none about-text-animationxxx"
                style="opacity: 0"
              >
                <!-- "hero-animation ml-lg-2" -->
                <img src="../images/servicetext-md.png" alt="" />
              </div>

              <!-- small -->
              <div
                class="sm-about-text d-flex justify-center d-sm-none about-text-animationxxx"
                style="opacity: 0"
              >
                <!-- class="hero-animation ml-lg-2" -->
                <img src="../images/servicetext-sm.png" alt="" />
              </div>

              <h5
                class="about-text-animationxxx text-center mx-md-13"
                style="opacity: 0"
              >
                Our Department is dedicated to providing<span
                  class="text-color-gold"
                >
                  service </span
                >to our Community. We proactively respond to the changing needs
                of the community and department through open communication,
                accountability and professionalism. Employees must have<span
                  class="text-color-gold"
                >
                  integrity </span
                >, providing service that demonstrates honesty, professionalism
                and dedication in all actions. Employees will treat others
                with<span class="text-color-gold"> respect </span>, treating
                everyone with dignity, empathy and<span class="text-color-gold">
                  fairness </span
                >, while demonstrating consistent, ethical and impartial
                treatment towards everyone.
              </h5>
            </div>
          </v-col>
        </v-row>
        <div
          style="width: 100%; height: 1px"
          id="intersect_abouttext"
          v-intersect="onIntersect_abouttext"
          v-if="anim1_ready"
        ></div>
      </v-container>

      <!-- application form -->
      <v-container class="application-padding-xxlarge">
        <v-row class="mb-12">
          <v-col
            cols="12"
            class="app-form d-flex flex-column justify-center align-center"
          >
            <!-- <img
              src="/ClientApp/public/images/startapplication.png"
              class=""
              alt=""
            /> -->

            <!-- large and extra large image -->
            <div class="lg-app-text d-none d-lg-flex justify-center">
              <img
                src="../images/startapplication.png"
                class="mr-lg-2"
                alt=""
              />
            </div>

            <!-- medium-->
            <div
              class="md-app-text d-none d-md-flex justify-md-center d-lg-none"
            >
              <img
                src="../images/startapplication-md.png"
                class="hero-animation ml-lg-2"
                alt=""
              />
            </div>

            <!-- small -->
            <div class="sm-app-text d-flex justify-center d-md-none">
              <img
                src="../images/startapplication-sm.png"
                class="ml-lg-2"
                alt=""
              />
            </div>
          </v-col>
        </v-row>

        <div id="app_form">
          <v-form
            v-model="valid"
            id="application_form"
            ref="formIn"
            class="pb-11"
          >
            <v-container class="">
              <v-row class="d-flex flex-column justify-center align-center">
                <v-col cols="12" lg="10" class="px-3 pt-lg-8">
                  <v-text-field
                    id="firstName"
                    :rules="nameRules"
                    name="firstName"
                    maxlength="60"
                    v-model="formIn.firstName"
                    label="First Name"
                    ref="firstName"
                    color="gold"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="10" class="px-3">
                  <v-text-field
                    id="lastName"
                    name="lastName"
                    :rules="nameRules"
                    maxlength="60"
                    v-model="formIn.lastName"
                    label="Last Name"
                    ref="lastName"
                    color="gold"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="10" class="px-3">
                  <v-text-field
                    id="email"
                    name="email"
                    maxlength="120"
                    v-model="formIn.email"
                    label="Email"
                    ref="email"
                    color="gold"
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="10" class="px-3">
                  <v-text-field
                    id="phoneNumber"
                    v-mask="'(###) ###-####'"
                    name="phoneNumber"
                    maxlength="14"
                    v-model="formIn.phoneNumber"
                    label="Phone Number"
                    ref="phoneNumber"
                    color="gold"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="10" class="px-3 mb-5">
                  <v-select
                    class=""
                    id="position"
                    v-model="formIn.position"
                    :items="positions"
                    label="Which Position are you interested in"
                    ref="position"
                    attach
                    color="gold"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="10" class="px-3">
                  <v-textarea
                    id="message"
                    name="message"
                    maxlength="4000"
                    v-model="formIn.message"
                    label="Message"
                    counter="4000"
                    color="gold"
                    value=""
                  ></v-textarea>
                </v-col>
                <!-- submit button -->
                <v-col cols="12" class="d-flex justify-center">
                  <v-btn
                    outlined
                    color="gold"
                    class="button"
                    @click="submit"
                    style="color: white !important"
                    >SUBMIT
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </v-container>
      <recruit_footer></recruit_footer>
    </v-main>
  </div>
</template>
<style></style>
<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .videojnb {
    background-size: cover;
    background-position: 50% 50%;
    position: absolute;
    margin: auto;
    width: 100%;
    height: 100%;
    right: -50%;
    bottom: -100%;
    top: -100%;
    left: -100%;
    object-fit: cover;
    z-index: -100;
  }
  .trans100 {
    transform: translateX(200%);
  }
  .transback100 {
    transform: translateX(-200%);
  }
  .hero_bg-video-overlay {
    background-image: linear-gradient(180deg, #0003 80%, black);
    position: absolute;
    inset: 0%;
  }

  .video-container {
    position: relative;
    width: 100%;
    height: 100vh; /* Full viewport height */
    overflow: hidden;
  }

  .video-container video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    // z-index: -1; /* Places video behind content */
  }

  .content-video {
    position: relative;
    top: 500px;
    z-index: 1; /* Ensures content is above video */
    color: white;
    text-align: center;
    padding: 20px;
  }

  .hero-text-container h4 {
    max-width: 880px;
    font-size: 1.5rem;
  }

  /* hero animation */

  .hero-animation {
    animation: fade-in 0.75s ease-in-out 0s forwards;
  }

  .hero-animation:nth-child(2) {
    opacity: 0;
    animation: fade-in 0.75s ease-in-out 0.5s forwards;
  }

  .hero-animation:nth-child(3) {
    opacity: 0;
    animation: fade-in 0.75s ease-in-out 1s forwards;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
      transform: translateX(15%);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* recruit animation */

  .recruit-left-animation {
    animation: rec-l-fade-in 0.75s ease-in-out 0.5s forwards;
  }

  @keyframes rec-l-fade-in {
    0% {
      opacity: 0;
      transform: translateX(-10%); /* Off-screen left */
    }
    100% {
      opacity: 1;
      transform: translateX(0); /* Final position */
    }
  }

  .recruit-right-animation {
    animation: rec-r-fade-in 0.75s ease-in-out forwards;
  }

  @keyframes rec-r-fade-in {
    0% {
      opacity: 0;
      transform: translateX(10%); /* Off-screen right */
    }
    100% {
      opacity: 1;
      transform: translateX(0); /* Final position */
    }
  }

  /* lateral animation */

  .lateral-left-animation {
    animation: lat-l-fade-in 0.75s ease-in-out forwards;
  }

  @keyframes lat-l-fade-in {
    0% {
      opacity: 0;
      transform: translateX(-10%); /* Off-screen left */
    }
    100% {
      opacity: 1;
      transform: translateX(0); /* Final position */
    }
  }

  .lateral-right-animation {
    animation: rec-r-fade-in 0.75s ease-in-out 0.5s forwards;
  }

  @keyframes lat-r-fade-in {
    0% {
      opacity: 0;
      transform: translateX(10%); /* Off-screen right */
    }
    100% {
      opacity: 1;
      transform: translateX(0); /* Final position */
    }
  }

  /* about pic animation */
  .about-pic-animation {
    animation: about-pic-fade-in 0.75s ease-in forwards;
  }

  @keyframes about-pic-fade-in {
    0% {
      opacity: 0;
      transform: translateX(0); /* Off-screen right */
    }
    100% {
      opacity: 1;
      transform: translateX(0); /* Final position */
    }
  }

  /* about text animation */
  .about-text-animation {
    opacity: 0;
    animation: about-text-fade-in 0.75s ease-in forwards;
  }
  .about-text-animation:nth-child(2) {
    opacity: 0;
    animation: about-text-fade-in 0.75s ease-in 7 forwards;
  }

  @keyframes about-text-fade-in {
    0% {
      opacity: 0;
      transform: translateY(20%); /* Off-screen right */
    }
    100% {
      opacity: 1;
      transform: translateY(0); /* Final position */
    }
  }

  .container {
    max-width: 100%;
  }
  #home-container {
    width: 100%;
    height: auto;
  }

  .hero-text-container {
    width: 100%;
    height: auto;
  }

  .hero-text-container h4 {
    max-width: 880px;
    opacity: 1;
    font-size: 1.5rem;
  }

  .sm-hero-text {
    margin-top: 8rem;
  }

  .sm-hero-text img {
    width: 93%;
  }

  .hero-text-btn,
  .recruit-text-btn,
  .lateral-text-btn {
    width: 160px;
    height: 55px !important;
    font-size: 1.25rem !important;
  }

  .sm-recruit-text,
  .sm-lateral-text,
  .sm-app-text {
    width: 100%;
  }

  .sm-recruit-text img,
  .sm-lateral-text img {
    width: 76%;
  }

  .sm-app-text {
    margin-top: 4rem;
  }

  /*   .sm-app-text img {
    justify-self: center;
  } */

  .text-color-gold {
    color: #ba9c58;
  }

  .text-weight-semibold {
    font-weight: 600;
  }

  .text-size-small {
    font-size: 1.2rem;
  }

  .text-size-med {
    font-size: 1.4rem;
  }

  .exp-header-style {
    color: #ba9c58;
    font-family: Oswald;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.2;
    text-transform: uppercase;
  }

  .recruit-padding-xxlarge {
    padding-top: 240px;
    padding-bottom: 145px;
  }

  .recruit-pic img,
  .lateral-pic img {
    width: 90%;
  }

  .recruit-text h5,
  .lateral-text h5,
  .about-text h5 {
    font-size: 1.3rem;
  }

  .theme--dark.v-expansion-panels:deep .v-expansion-panel {
    background-color: black !important;
  }

  .v-expansion-panels {
    z-index: 0 !important;
  }

  .recruit-expansion li,
  .lateral-expansion li {
    font-size: 1.4rem;
  }

  .sm-about-text {
    margin-top: 3rem;
  }

  .sm-about-text img {
    width: 96%;
    justify-self: center;
  }

  .about-pic img {
    width: 100vw;
    border-top: 1px solid #ba9c58;
    border-bottom: 1px solid #ba9c58;
    opacity: 1;
  }

  // button css
  /*   .button.is-small {
    padding: 0.5rem 1.25rem;
    font-size: 1.5rem;
  } */
  .button {
    border: 1px solid white;
    background-color: #ba9c58;
    color: #fff !important;
    text-align: center;
    font-family: Oswald;
    text-transform: uppercase;
    padding: 1rem 1rem !important;
    font-size: 1.25rem;
    font-weight: 600;
    text-decoration: none;
  }
  .w-button {
    display: inline-block;
    padding: 9px 15px;
    background-color: #3898ec;
    color: white;
    border: 0;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
    border-radius: 0;
  }

  .full-width {
    width: 100%;
  }

  #application_form {
    border: 2px solid #ba9c58;
    border-radius: 10px;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .button {
    color: #fff !important;
    font-size: 1.75rem;
    padding: 1rem 1rem !important;
  }

  .recruit-padding-xxlarge {
    padding-top: 430px;
    padding-bottom: 145px;
  }
  .recruit-text h5,
  .lateral-text h5,
  .about-text h5 {
    font-size: 1.6rem;
  }

  // .sm-hero-text {
  //   margin-top: 12rem;
  // }

  h4.hero-sub-text {
    font-size: 1.75rem;
  }

  .sm-recruit-text,
  .sm-lateral-text {
    margin-top: 0;
  }

  .recruit-pic img,
  .lateral-pic img {
    width: 100%;
    height: auto;
  }

  .recruit-pic img {
    margin-top: 7rem;
  }

  .lateral-pic img {
    margin-top: 13rem;
  }

  .md-hero-text {
    width: 100%;
    margin-top: 24rem;
  }

  .md-hero-text img {
    width: 98%;
  }

  .md-recruit-text,
  .md-lateral-text {
    width: 100%;
  }

  .md-recruit-text img {
    width: 85%;
  }

  .md-lateral-text img {
    width: 77%;
  }

  .md-recruit,
  .md-lateral {
    width: 98%;
    margin: 0 auto;
  }

  .recruit-text,
  .lateral-text {
    width: 52%;
  }

  .about-text {
    margin-top: 8rem;
  }

  .md-about-text,
  .md-app-text {
    width: 100%;
  }

  .md-app-text {
    margin-top: 8rem;
  }

  .md-about-text img {
    width: 90%;
  }

  .md-app-text img {
    width: 62%;
  }

  #app_form {
    width: 80%;
    margin: 0 auto;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .videojnb {
    background-size: cover;
    background-position: 50% 50%;
    position: absolute;
    margin: auto;
    width: 100%;
    height: 100%;
    right: -100%;
    bottom: -100%;
    top: -100%;
    left: -100%;
    object-fit: cover;
    z-index: -100;
  }

  .lg-animation-div img {
    margin: 4rem 0 0 8.5rem;
  }

  .lg-animation-div h4 {
    margin-left: 10rem;
  }

  .lg-animation-div a {
    margin-left: 10rem;
  }

  .recruit-padding-xxlarge {
    padding-top: 240px;
    padding-bottom: 145px;
  }

  .lg-hero-text,
  .lg-lateral-text,
  .lg-app-text {
    margin-top: 2rem;
  }

  .about-text {
    margin-top: 0;
  }
}

/* 1440 media q */
@media (min-width: 1440px) {
  .w-background-video {
    background-size: contain;
    background-position: 50% 50%;
    position: absolute;
    margin: auto;
    width: 100vw;
    height: 50%;
    right: -100%;
    bottom: -100%;
    top: -100%;
    left: -100%;
    object-fit: cover;
    z-index: 0;
  }
  .hero-text-container {
    padding-top: 85px;
  }
  .hero-text-container img {
    width: 1100px;
    height: auto;
  }

  .hero-text-btn,
  .recruit-text-btn,
  .lateral-text-btn {
    width: 210px;
    height: auto;
    font-size: 1.75rem !important;
  }

  .hero-text-container h4 {
    font-size: 1.75rem;
  }

  .recruit-padding-xxlarge {
    padding-top: 240px;
    padding-bottom: 190px;
  }

  .lateral-padding-xxlarge {
    padding-bottom: 160px;
  }

  .application-padding-xxlarge {
    padding: 0 0 150px 0;
  }

  .recruit-text,
  .lateral-text {
    width: 50%;
  }

  .about-text {
    width: 100%;
    padding-bottom: 160px;
  }

  .about-text h5 {
    width: 85%;
  }

  .about-text-bckground {
    background-image: url(../images/rpd-faded2.png);
    // opacity: 0.1;
    background-position: center;
    background-size: 98%;
  }

  .recruit-text img,
  .lateral-text img {
    width: 557px;
    height: auto;
  }

  .about-text img {
    width: 775px;
  }

  .recruit-pic img,
  .lateral-pic img {
    width: 100%;
    height: auto;
    margin-top: 0;
  }

  .app-form img {
    width: 65%;
  }

  .recruit-expansion,
  .lateral-expansion {
    width: 100%;
  }

  .qualification-expansion {
    width: 50%;
  }

  .qual-list {
    width: 100%;
  }

  .recruit-pic,
  .lateral-pic {
    width: 45%;
  }

  .about-pic img {
    width: 100vw;
    border-top: 1px solid #ba9c58;
    border-bottom: 1px solid #ba9c58;
    opacity: 1;
  }

  .about-pic-overlay {
    background-color: #00000073;
  }

  #app_form {
    width: 50%;
    margin: 0 auto;
  }

  #application_form {
    width: 100%;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
import recruit_footer from "./recruit_footer.vue";
import ToDo from "./ToDo.vue";

export default {
  name: "Home",
  components: {
    banner,
    recruit_footer,
    ToDo,
  },
  mixins: [bus_common],
  data() {
    return {
      valid: false,
      reqRules: [(v) => !!v || "Fiels is required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 60 || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      anim1_ready: false,
      intersect4: 0,
      intersect3: 0,
      intersect2: 0,
      intersect1: 0,
      currentTime: 0,
      vid_go: false,
      formIn: {
        recuitId: 0,
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        position: "",
        message: "",
      },
      formIn_new: {
        recuitId: 0,
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        position: "",
        message: "",
      },
      formIn_dev: {
        recuitId: 0,
        firstName: "Dell",
        lastName: "Ray",
        email: "jvonmolt@gmail.com",
        phoneNumber: "(775) 622-9121",
        position: "Police Officer Recruit",
        message:
          "Doing me a frighten heck fluffer yapper what a nice floof, such treat very good spot doggo. Maximum borkdrive smol borking doggo with a long snoot for pats shibe very good spot wow very biscit blep, blop yapper heckin angery woofer waggy wags",
      },
      positions: ["Police Officer Recruit", "Lateral Police Office"],
    };
  },
  watch: {},
  methods: {
    submit() {
      if (this.$refs.formIn.validate() == false) {
        this.swall_it(
          "Submit Status",
          "Some items area not correct. Please look at the red fields.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.recruit = this.mno(this.formIn);

      this.show_loader(true);

      formIn.apiname = "submit_recruit";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);

          this.swall_it("Submit Status", "Success!", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error submit letter data", msg, "error", null, null);
        });
    },
    onIntersect_abouttext() {
      console.log("about_text1: " + this.intersect4);
      if (this.intersect4 == 1) {
        console.log("about_text2: " + this.intersect4);
        let lst_right_recruit = document.querySelectorAll(
          ".about-text-animationxxx"
        );
        lst_right_recruit.forEach((element) => {
          element.classList.replace(
            "about-text-animationxxx",
            "about-text-animation"
          );
        });
      }

      this.intersect4 += 1;
      console.log("about_pic3: " + this.intersect4);
    },
    onIntersect_aboutpic() {
      console.log("about_pic: " + this.intersect3);
      if (this.intersect3 == 1) {
        console.log("about_pic2: " + this.intersect3);
        let lst_right_recruit = document.querySelectorAll(
          ".about-pic-animationxxx"
        );
        lst_right_recruit.forEach((element) => {
          element.classList.replace(
            "about-pic-animationxxx",
            "about-pic-animation"
          );
        });
      }

      this.intersect3 += 1;
      console.log("about_pic3: " + this.intersect3);
    },
    onIntersect2() {
      console.log("lat_cnt: " + this.intersect2);
      if (this.intersect2 == 1) {
        console.log("onIntersect1");
        let lst_right_recruit = document.querySelectorAll(
          ".lateral-right-animationxxx"
        );
        lst_right_recruit.forEach((element) => {
          element.classList.replace(
            "lateral-right-animationxxx",
            "lateral-right-animation"
          );
        });
        let lst_left_recruit = document.querySelectorAll(
          ".lateral-left-animationxxx"
        );
        lst_left_recruit.forEach((element) => {
          element.classList.replace(
            "lateral-left-animationxxx",
            "lateral-left-animation"
          );
        });
      }

      this.intersect2 += 1;
      console.log("lat_cnt2: " + this.intersect2);
    },
    onIntersect1() {
      console.log("cnt: " + this.intersect1);
      if (this.intersect1 == 1) {
        console.log("onIntersect1");
        let lst_right_recruit = document.querySelectorAll(
          ".recruit-right-animationxxx"
        );
        lst_right_recruit.forEach((element) => {
          element.classList.replace(
            "recruit-right-animationxxx",
            "recruit-right-animation"
          );
        });
        let lst_left_recruit = document.querySelectorAll(
          ".recruit-left-animationxxx"
        );
        lst_left_recruit.forEach((element) => {
          element.classList.replace(
            "recruit-left-animationxxx",
            "recruit-left-animation"
          );
        });
      }

      this.intersect1 += 1;
      console.log("cnt2: " + this.intersect1);
    },
    onTimeUpdate(event) {
      this.currentTime = event.target.currentTime;
    },
    govid() {
      this.vid_go = true;
    },
    message1() {
      alert("This button does nothing yet.");
    },

    message2() {
      alert("when clicked this ");
    },

    init(self) {
      this.show_loader(false);
      this.formIn = this.mno(this.formIn_new);
      setTimeout(() => {
        // var video = document.getElementById("herovideo");
        // video.play();
        self.anim1_ready = true;
      }, 1000);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
